import React, { Component } from "react";
import { Spinner } from "reactstrap";
import swal from "sweetalert";
import { axiosPost } from "../../utils/AxiosApi";
import { URL } from "../../utils/Constants";
import { displayErrorAlert } from "../../utils/Utils";

export class Feedback extends Component {
  state = {
    feedbackTypes: [],
    feedbackTypeId: "",
    description: "",
    spinner: false,
    anonymous: true,
    rating: 0,
    recipientId: "",
    peopleList: [],
  };

  handleChange = (e) => {
    let { name, value } = e.target;
    this.setState({
      [name]: value,
    });
  };

  componentDidMount() {
    this.getFeedbackTypes();
    this.getPeopleListForFeedback();
  }

  getPeopleListForFeedback = () => {
    axiosPost(URL.getPeopleListForFeedback, {}, (response) => {
      if (response.status === 200) {
        this.setState({
          peopleList: response.data.data,
        });
      }
    });
  };

  getFeedbackTypes = () => {
    axiosPost(URL.getFeedbackTypes, {}, (response) => {
      if (response.status === 200) {
        this.setState({
          feedbackTypes: response.data.data,
        });
      }
    });
  };

  handleSubmitFeedback = () => {
    let data = {
      feedbackTypeId: this.state.feedbackTypeId,
      description: this.state.description,
      isAnonymous: this.state.anonymous,
      rating: this.state.rating,
      feedbackTo: this.state.recipientId,
    };

    if (this.state.feedbackTypeId !== "") {
      this.setState(
        {
          spinner: true,
        },
        () => {
          axiosPost(
            URL.insertFeedback,
            data,
            (response) => {
              if (response.status === 200) {
                swal("Success", "Feedback successfully submitted");
                this.setState({
                  spinner: false,
                  feedbackTypeId: "",
                  description: "",
                  anonymous: true,
                  rating: 0,
                  recipientId: "",
                });
              }
            },
            (err) => {
              displayErrorAlert(err);
              this.setState({
                spinner: false,
              });
            },
          );
        },
      );
    } else {
      swal("Oops", "Feedback type is required!!");
    }
  };

  handleCancel = () => {
    if (this.props.handleCancel) {
      this.props.handleCancel();
    }
    
    this.setState({
      feedbackTypeId: "",
      description: "",
      anonymous: true,
      rating: 0,
      recipientId: "",
    });
  };

  render() {
    return (
      <>
        {this.state.spinner ? (
          <div className="fullWindow-Spinner">
            <div>
              <Spinner color="white"></Spinner>
            </div>
            <div style={{ fontSize: "16px", marginTop: "15px" }}>
              Please wait !! Processing.....
            </div>
          </div>
        ) : null}

        <div className="feedback-container mt-2 mb-2">
          <div className="container">
            <div className="mt-2">
              Feedback Type
              <span
                className="tt-assessment-module-mandatory"
                style={{ paddingLeft: "5px" }}
              >
                *
              </span>
              <select
                className="form-control"
                name="feedbackTypeId"
                onChange={(e) => this.handleChange(e)}
                value={this.state.feedbackTypeId}
              >
                <option selected disabled value="">
                  Select type
                </option>
                {this.state.feedbackTypes.map((fb) => (
                  <option value={fb.feedbackTypeId}>
                    {fb.feedbackTypeName}
                  </option>
                ))}
              </select>
              <div className="mt-2">
                Send feedback to
                <span
                  className="tt-assessment-module-mandatory"
                  style={{ paddingLeft: "5px" }}
                >
                  *
                </span>
                <select
                  value={this.state.recipientId}
                  onChange={(e) =>
                    this.setState({ recipientId: e.target.value })
                  }
                  className="form-control"
                >
                  <option value="" disabled selected>
                    Select
                  </option>
                  {this.state.peopleList.map((r) => (
                    <option key={r.id} value={r.id}>
                      {r.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="mt-2">
              Rating
              <span
                className="tt-assessment-module-mandatory"
                style={{ paddingLeft: "5px" }}
              >
                *
              </span>
              <div className="stars">
                {[1, 2, 3, 4, 5].map((star) => (
                  <span
                    key={star}
                    className={`star ${star <= this.state.rating ? "active" : ""}`}
                    onClick={() => this.setState({ rating: star })}
                  >
                    ★
                  </span>
                ))}
              </div>
            </div>

            <div className="mt-2">
              Comment
              {/* <span
                className="tt-assessment-module-mandatory"
                style={{ paddingLeft: "5px" }}
              >
                *
              </span> */}
              <textarea
                name="description"
                placeholder="Write your feedback..."
                rows="5"
                className="form-control"
                value={this.state.description}
                onChange={(e) => this.handleChange(e)}
              ></textarea>
            </div>
            <div className="form-group form-check mt-2">
              <input
                type="checkbox"
                className="form-check-input"
                id="anonymousCheck"
                checked={this.state.anonymous}
                onChange={(e) => this.setState({ anonymous: e.target.checked })}
              />
              <label className="form-check-label" htmlFor="anonymousCheck">
                Submit anonymously
              </label>
            </div>

            {/* <div className="mt-3 text-right">
              <button
                className="tt-button tt-button-primary"
                onClick={this.handleSubmitFeedback}
              >
                Submit
              </button>
            </div> */}
            <div className="actions">
              <button className="submit" onClick={this.handleSubmitFeedback}>
                Submit
              </button>

              <button className="cancel" onClick={this.handleCancel}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default Feedback;
